import { open_in_new_tab } from '@phi/util/window';
import { ONSHAPE_CLIENT_ID } from '@phi/config/frontend';

export const open_onshape_oauth_page = () => open_in_new_tab(`https://oauth.onshape.com/oauth/authorize?response_type=code&state=standalone&client_id=${ONSHAPE_CLIENT_ID}`);
